module.exports = __webpack_public_path__ + "img/1-05.93c0869c.jpg";